module.exports = __webpack_public_path__ + "img/offers.48210e78.svg";